import { useState } from 'react';
import { Glyphicon } from 'react-bootstrap';
import { IDonorSurgeon, ISwapQualityIssueForReport } from '@nkr/models/index';

interface IProps {
    data: {
        donorSurgeon: IDonorSurgeon,
        issues: ISwapQualityIssueForReport[],
        rNum: number
    },
    expanded: boolean,
    onExpand: (id: number, expanded: boolean) => void
}

const DonorSurgeonRow = (props: IProps) => {
    const [showAllText, setShowAllText] = useState(false);

    const handleExpand = () => {
        props.onExpand(props.data.donorSurgeon.id, props.expanded);
    };

    const handleShowAllText = (e: React.FormEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setShowAllText(!showAllText);
    };

    const renderDescription = (description: string) => {
        let partial = description.substring(0, 254);

        if (showAllText) {
            return <>{description} <a href='' onClick={handleShowAllText}>(less)</a></>;
        } else {
            if (description.length > partial.length) {
                return <>{partial}... <a href='' onClick={handleShowAllText}>(more)</a></>;
            } else {
                return <>{partial}</>;
            }
        }
    };

    const glyphIcon = props.expanded ? 'triangle-bottom' : 'triangle-right';

    return (
        <>
            <tr>
                <td style={{ textAlign: 'center' }}><Glyphicon glyph={glyphIcon} onClick={handleExpand} /></td>
                <td style={{ textAlign: 'center' }}>{props.data.rNum}</td>
                <td>{props.data.donorSurgeon.centerAlias}</td>
                <td>{props.data.donorSurgeon.fullName}</td>
                <td style={{ textAlign: 'center' }}>{props.data.donorSurgeon.issueCount}</td>
                <td style={{ textAlign: 'center' }}>{props.data.donorSurgeon.count}</td>
                <td style={{ textAlign: 'center' }}>{props.data.donorSurgeon.issueRate}%</td>
            </tr>

            {props.expanded ?
                <tr>
                    <td colSpan={6}>
                        <table className='table table-striped table-condensed' style={{ width: '95%', marginLeft: 'auto', marginRight: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}>Recipient Center</th>
                                    <th style={{ width: '10%' }}>Recipient Surgeon</th>
                                    <th style={{ width: '15%' }}>Recipient Issue Type(s)</th>
                                    <th>Recipient Center Comments</th>
                                    <th style={{ width: '10%' }}>Nephrectomy Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.issues.map((issue, index) =>
                                    <tr key={index}>
                                        <td>{issue.recipientCenterName}</td>
                                        <td>{issue.recipientSurgeonName}</td>
                                        <td>
                                            {issue.recipientSwapQualityIssueTypes.map(item =>
                                                <div>{item}</div>
                                            )}
                                        </td>
                                        <td>{renderDescription(issue.recipientIssueDescription)}</td>
                                        <td>{issue.nephrectomyDate}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </td>
                </tr>
                : null}
        </>
    );
}

export default DonorSurgeonRow;